// pages/Dashboard.jsx
import HomeLayout from "../../components/home/HomeLayout";
import HomePage from "../../components/home/HomePage";

export default function Dashboard() {
  return (
    <HomeLayout>
      <HomePage />
    </HomeLayout>
  );
}
